export default class Storage {
  static storage = localStorage;

  static setItem(key, value, expireTimeInSeconds = 10) {
    this.storage.setItem(
      key,
      JSON.stringify({
        data: value,
        createdAt: new Date().getTime(),
        expireTimeInMilliseconds: expireTimeInSeconds * 1000,
      }),
    );
  }

  static fetchItem(key) {
    return JSON.parse(this.storage.getItem(key));
  }

  static isExpired(key) {
    const item = this.fetchItem(key);
    if (
      item &&
      new Date().getTime() > item.createdAt + item.expireTimeInMilliseconds
    ) {
      return true;
    }
    return false;
  }

  static getExpiryInSeconds(key) {
    const item = this.fetchItem(key);
    if (item && !this.isExpired(key)) {
      return (
        (item.createdAt +
          item.expireTimeInMilliseconds -
          new Date().getTime()) /
        1000
      );
    }
  }

  static getItem(key) {
    if (this.isExpired(key)) {
      return null;
    } else {
      const item = this.storage.getItem(key);
      return JSON.parse(item).data;
    }
  }

  static removeItem(key) {
    this.storage.removeItem(key);
  }

  static clear() {
    this.storage.clear();
  }
}
